import { Component, OnInit } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
@Component({
  selector: 'my-nota-credito-eliminar',
  styles: [],
  templateUrl: './nota-credito-eliminar.component.html',
  providers: [generalService]
})
export class NotaCreditoEliminarComponent implements OnInit {

  mensaje: string = '';
  constructor(
    public dataService: DataService,
    private formBuilder: FormBuilder,
    private _generalService: generalService) {
   
  }

  ngOnInit() {
   
  }

  aceptar() {
    this.cancelNotaCredito();
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  cancelNotaCredito() {
    const loacs  = sessionStorage.getItem('acslo');
    const notaCredito = {
      loacs: loacs,
      BILL_CREDIT_NOTE_ID: this.dataService.id,
      idCompania: this.dataService.factura.idCompania,
      ORGANIZATION_ID: this.dataService.factura.idOrganizacion,
      UUID: this.dataService.factura.uuid,
      TOTAL: this.dataService.factura.TOTAL,
      MOTIVO: this.dataService.factura.MOTIVO,
      //CUSTOMER_ID: this.dataService.factura.CUSTOMER_ID,
      CUSTOMER_ID:null,
    };
    console.warn(this.dataService);
    console.warn(notaCredito);
    
    this._generalService.metodoCallParams(notaCredito, `NotaCredito/cancel/`).subscribe(
          (result) => {
            this._generalService.toastCall('Se realizó la solcitud de cancelación exitosamente!');
            this.cerrarModal();
            },
          (error) => {
            console.log( error as any);
            this.cerrarModal();
          }
        );
    
    }
}



// WEBPACK FOOTER //
// ./src/app/nota-credito/consultar-eliminar/nota-credito-eliminar.component.ts